import { render, staticRenderFns } from "./ReassignedUserHistoryDialog.vue?vue&type=template&id=540724d8"
import script from "./ReassignedUserHistoryDialog.js?vue&type=script&lang=js&external"
export * from "./ReassignedUserHistoryDialog.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports